export default __webpack_public_path__ + "static/media/Lianel-Artiles-Dev-CV-Eng.3e821281.pdf";